<template>
  <div class="persona-notes">
    <p class="persona-hint">필요한 내용만 남겨도 됩니다. 작성 여부와 관계없이 모든 분석 단계를 볼 수 있습니다.</p>
    <budget-planner v-if="course.id==='first-home'" v-model="plan.budget" />
    <section class="persona-record" aria-labelledby="persona-note-title">
      <header><h3 id="persona-note-title">이 단계의 메모</h3><p>{{ step.title }}에서 확인한 내용을 자유롭게 남기세요.</p></header>
      <div class="persona-record-grid">
        <label>확인한 사실<textarea v-model="record.finding" maxlength="6000" rows="3" placeholder="차트에서 눈여겨본 내용" /></label>
        <label>출처·기준일·비교 조건<textarea v-model="record.source" maxlength="6000" rows="3" placeholder="출처, 관측 월, 지역, 면적, 연식, 거래 유형" /></label>
        <label>반대 근거·미확인 사항<textarea v-model="record.risk" maxlength="6000" rows="3" placeholder="더 확인하고 싶은 내용" /></label>
        <label>다음에 확인할 일<textarea v-model="record.next" maxlength="6000" rows="3" placeholder="현장 확인, 비용 견적, 자금 날짜 등" /></label>
      </div>
    </section>
    <section class="persona-compare" aria-labelledby="persona-compare-title">
      <header><h3 id="persona-compare-title">후보 3곳 비교</h3><p>과정 전체에서 함께 사용하는 비교표입니다.</p></header>
      <div class="persona-candidate-grid">
        <fieldset v-for="(candidate,index) in plan.candidates" :key="index">
          <legend>후보 {{ index+1 }}</legend>
          <label>지역·단지·매물명<input v-model="candidate.name" maxlength="1000" /></label>
          <label>면적·연식·기간 등 비교 조건<textarea v-model="candidate.condition" rows="2" maxlength="1000" /></label>
          <label>가격·필요 자금<input v-model="candidate.price" maxlength="1000" placeholder="금액과 단위를 함께 입력" /></label>
          <label>출처와 가격 근거<textarea v-model="candidate.evidence" rows="2" maxlength="1000" /></label>
          <label>미확인·반대 근거<textarea v-model="candidate.risk" rows="2" maxlength="1000" /></label>
        </fieldset>
      </div>
    </section>
    <section class="persona-decision" aria-labelledby="persona-decision-title">
      <header><h3 id="persona-decision-title">내 판단 정리</h3><p>기록해 둔 결정과 다시 확인할 조건을 관리합니다.</p></header>
      <div class="persona-record-grid">
        <label>현재 결정<select v-model="plan.decision.choice"><option value="">선택해 주세요</option><option>실행 검토</option><option>보유·유지 검토</option><option>매도·정리 검토</option><option>대기·추가 확인</option><option>후보 제외</option></select></label>
        <label>재검토 날짜<input v-model="plan.decision.date" type="date" /></label>
        <label>선택 근거<textarea v-model="plan.decision.reason" rows="3" maxlength="6000" /></label>
        <label>실행 조건<textarea v-model="plan.decision.execute" rows="3" maxlength="6000" /></label>
        <label>중단 조건<textarea v-model="plan.decision.stop" rows="3" maxlength="6000" /></label>
      </div>
    </section>
    <footer class="persona-savebar">
      <div><strong>{{ course.short }} 분석 기록</strong><span role="status">{{ saveStatus || '저장한 기록은 이 브라우저에서 다시 볼 수 있습니다.' }}</span></div>
      <button type="button" @click="$emit('save')">이 브라우저에 저장</button>
      <button type="button" @click="$emit('download')">분석 기록 내려받기</button>
    </footer>
  </div>
</template>
<script>
import BudgetPlanner from './BudgetPlanner.vue';
export default {
  name:'PersonaNotes',components:{BudgetPlanner},
  props:{course:{type:Object,required:true},step:{type:Object,required:true},plan:{type:Object,required:true},saveStatus:{type:String,default:''}},
  computed:{record(){return this.plan.steps[this.step.id-1];}}
};
</script>
